/** @jsx jsx */

import PropTypes from 'prop-types';

import { Checkbox } from '@zapier/design-system';
import { Colors } from '@zapier/theme';
import { jsx } from '@emotion/core';
import { labelStyles, withModifier } from '@zapier/common-utils';

const Styles = labelStyles(__filename, {
  root: {
    paddingBottom: '10px !important',
    minHeight: 'auto !important',
  },
  label: ({ isDisabled }) => [
    {
      display: 'flex',
      alignItems: 'center',
    },
    !isDisabled &&
      withModifier('disabled', { color: `${Colors.adamantium} !important` }),
  ],
  labelText: {
    cursor: 'pointer',
    fontSize: 14,
    margin: 0,
    marginLeft: 10,
    userSelect: 'none',
    fontWeight: 'normal',
  },
  helpText: { marginLeft: '3em' },
});

const CheckboxField = props => {
  const { field, onChange } = props;

  return (
    <div className="fm-field" css={Styles.root}>
      <label
        className="fm-label"
        css={Styles.label({ isDisabled: !field.disabled })}
      >
        <Checkbox
          checked={field.value}
          disabled={field.disabled}
          name={field.key}
          onChange={e => onChange(e.target.checked, { field })}
          value={field.key}
        />
        <span css={Styles.labelText}>{field.label}</span>
      </label>
      {field.helpTextHtml && (
        <div className="fm-help" css={Styles.helpText}>
          <p dangerouslySetInnerHTML={{ __html: field.helpTextHtml }} />
        </div>
      )}
    </div>
  );
};

CheckboxField.propTypes = {
  field: PropTypes.object,
};

export default CheckboxField;
